<template>
  <div>
    <a-form
      v-if="changePasswordType === 0"
      class="user-layout-change-password"
      :form="form"
      @submit.prevent="handleChangePassword"
    >
      <a-row class="content-panle margin-0 padding-tb-0" :gutter="24">
        <a-col :span="16" class="padding-tb-md">
          <h3 class="panle-head" style="margin-bottom:16px">
            {{ $t('userCenter.changePasswordTitle') }}
          </h3>
          <!-- 密码 -->
          <a-col :span="24">
            <a-popover
              placement="rightTop"
              :trigger="['focus']"
              :getPopupContainer="trigger => trigger.parentElement"
              v-model="showPasswordTip"
            >
              <template slot="content">
                <div :style="{ width: '240px' }">
                  <div :class="['user-change-password', passwordLevelClass]">
                    {{ $t('userCenter.passwordStrength') }}：
                    <span>{{ passwordLevelName }}</span>
                  </div>
                  <a-progress
                    :percent="passwordStrength"
                    :showInfo="false"
                    :strokeColor="passwordLevelColor"
                  />
                  <div style="margin-top: 10px;">
                    <span>{{ $t('userCenter.passwordTips') }}</span>
                  </div>
                </div>
              </template>

              <a-form-item :label="$t('userCenter.passwordTxt')">
                <a-input-password
                  type="password"
                  @focus="
                    () => {
                      showPasswordTip = true
                    }
                  "
                  @blur="
                    () => {
                      showPasswordTip = false
                    }
                  "
                  autocomplete="false"
                  :placeholder="$t('userCenter.passwordTxt')"
                  v-decorator="[
                    'password',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('userCenter.passwordBlank')
                        },
                        { validator: this.handlePasswordLevel }
                      ],
                      validateTrigger: ['change', 'blur']
                    }
                  ]"
                >
                  <a-icon
                    slot="prefix"
                    type="lock"
                    :style="{ color: 'rgba(0,0,0,.25)' }"
                  />
                </a-input-password>
              </a-form-item>
            </a-popover>
          </a-col>

          <!-- 确认密码 -->
          <a-col :span="24">
            <a-form-item :label="$t('userCenter.repasswordTxt')">
              <a-input-password
                type="password"
                autocomplete="false"
                :placeholder="$t('userCenter.repasswordTxt')"
                v-decorator="[
                  'repassword',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('userCenter.repasswordBlank')
                      },
                      { validator: handlePasswordCheck }
                    ],
                    validateTrigger: ['blur']
                  }
                ]"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input-password>
            </a-form-item>
          </a-col>

          <!-- 绑定的手机号 -->
          <a-col :span="24">
            <a-form-item :label="$t('userCenter.bindPhoneTxt')">
              <a-input
                :placeholder="$t('userCenter.bindPhoneTxt')"
                disabled
                :value="$store.state.userInfo.phone"
              >
                <a-icon
                  slot="prefix"
                  type="mobile"
                  :style="{ color: 'rgba(0,0,0,.25)' }"
                />
              </a-input>
            </a-form-item>
          </a-col>
          <!-- 手机验证码 -->
          <a-col :span="24">
            <a-row :gutter="24">
              <a-col class="gutter-row" :span="16">
                <a-form-item :label="$t('userCenter.varifyCode')">
                  <a-input
                    type="text"
                    :placeholder="$t('userCenter.varifyCode')"
                    :maxLength="6"
                    v-decorator="[
                      'verifyCode',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('userCenter.varifyCodeBlank')
                          }
                        ],
                        validateTrigger: 'blur'
                      }
                    ]"
                  >
                    <a-icon
                      slot="prefix"
                      type="mail"
                      :style="{ color: 'rgba(0,0,0,.25)' }"
                    />
                  </a-input>
                </a-form-item>
              </a-col>
              <a-col class="gutter-row" :span="8" style="margin-top:44px">
                <a-button
                  class="phone-verify-code-btn"
                  :disabled="gettingVerifyCode"
                  @click.stop.prevent="handleGetPhoneVerifyCode"
                  v-text="
                    (!gettingVerifyCode && $t('userCenter.varifyCodeBtn')) ||
                      timeCountDown + ' s'
                  "
                ></a-button>
              </a-col>
            </a-row>
          </a-col>

          <a-col :span="24" style="margin-top: 16px;">
            <a-button
              type="primary"
              html-type="submit"
              :disabled="btnSubmit"
              :loading="btnSubmit"
            >
              {{ $t('userCenter.changePWDBtn') }}
            </a-button>
          </a-col>
        </a-col>
      </a-row>
    </a-form>

    <div v-if="changePasswordType === 1">
      <a-result
        status="success"
        :title="$t('userCenter.changePasswordSuccess')"
        :subTitle="$t('userCenter.changePasswordSuccessBrief')"
      >
        <template v-slot:extra>
          <p style="font-size:16px">
            {{ reLoginTime }}s {{ $t('userCenter.reloginTips') }}
          </p>
          <a-button type="primary" @click="handleBackToSignIn">{{
            $t('userCenter.reLoginBtn')
          }}</a-button>
        </template>
      </a-result>
    </div>
    <Verify
      @success="sendSuccess"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>

<script>
import Verify from '@/components/verifition/Verify'
import { mapMutations, mapState } from 'vuex'
import {
  userSignOut,
  changePassword,
  sendChangePasswordPhoneCode,
  isSameWithOldPasswoed
} from '@/api/userMana'

// const levelNames = {
//   0: '低',
//   1: '低',
//   2: '中',
//   3: '强'
// }
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
export default {
  name: 'userCenterChangePassword',
  components: { Verify },
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      form: this.$form.createForm(this),

      changePasswordType: 0, // 修改密码状态 0：还没修改密码；1：修改密码成功

      btnSubmit: false, // 是否正在提交修改密码

      showPasswordTip: false, // 密码强度提示框
      passwordLevel: 0, // 设置密码的等级
      passwordStrength: 10, // 密码强度在强度条中的百分比

      gettingVerifyCode: false, // 是否已经点击‘获取验证码’
      timeCountDown: 60, // 获取手机验证码倒计时

      reLoginTime: 5
    }
  },
  computed: {
    ...mapState(['lang']),

    passwordLevelClass() {
      return levelClass[this.passwordLevel]
    },
    passwordLevelName() {
      switch (this.passwordLevel) {
        case 2:
          return this.$t('userCenter.passwordLevel2')
        case 3:
          return this.$t('userCenter.passwordLevel3')
        default:
          return this.$t('userCenter.passwordLevel1')
      }
      // return levelNames[this.passwordLevel]
    },
    passwordLevelColor() {
      return levelColor[this.passwordLevel]
    }
  },
  created() {},
  deactivated() {
    // this.form.resetFields()
  },
  methods: {
    ...mapMutations([
      'refreshUserInfo',
      'resetKeepAliveInclude',
      'resetSysRepeatDataNum'
    ]),

    handleChangePassword() {
      this.form.validateFields(async (err, values) => {
        // console.log('------handleChangePassword-------', err, values)
        if (!err) {
          try {
            this.btnSubmit = true
            await changePassword({
              password: values.password,
              token: values.verifyCode,
              userId: this.userInfo.id
            })
            this.btnSubmit = false
            this.changePasswordType = 1
            // 开启返回登录倒计时
            this.interval = setInterval(() => {
              if (this.reLoginTime-- <= 0) {
                this.handleBackToSignIn()
                clearInterval(this.interval)
                this.interval = null
              }
            }, 1000)
          } catch (error) {
            this.btnSubmit = false
            this.resetPhoneCode()
          }
        }
      })
    },

    // 判断密码是否与旧密码一致
    hasPasswordRepeat(value, callback) {
      let vm = this
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        this.timer = null
        if (value) {
          try {
            const res = await isSameWithOldPasswoed({ newPassword: value })
            if (res.data.collection[0]) {
              callback('与旧密码相同，请输入不同的新密码')
              return
            }
            callback()
          } catch (error) {
            callback()
          }
        }
      }, 1000)
    },
    // 判断输入密码是否为空、是否强度不够
    handlePasswordLevel(rule, value, callback) {
      let level = 0

      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.passwordLevel = level
      this.passwordStrength = level * 30
      if (!value) {
        callback()
        return
      }

      if (value.length < 8 || value.length > 16) {
        callback(new Error(this.$t('userCenter.passwordBlank')))
        return
      }
      if (level >= 2) {
        if (level >= 3) {
          this.passwordStrength = 100
        }
        this.hasPasswordRepeat(value, callback)
      } else {
        if (level === 0) {
          this.passwordStrength = 10
        }
        callback(new Error(this.$t('userCenter.passwordWarn')))
      }
    },
    // 判断密码输入是否一致
    handlePasswordCheck(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      const password = this.form.getFieldValue('password')
      if (password && value.trim() !== password.trim()) {
        callback(new Error(this.$t('userCenter.repasswordWarn')))
      } else {
        callback()
      }
    },

    // 触发获取验证码
    handleGetPhoneVerifyCode(e) {
      this.$refs.verify.show()
    },
    // 重置发送手机验证码按钮
    resetPhoneCode() {
      // 关闭倒计时
      clearInterval(this.interval)
      // 重置倒计时时间
      this.timeCountDown = 60
      // 恢复请求手机验证码按钮状态
      this.gettingVerifyCode = false
    },

    // 修改密码成功后返回登录，需要先退出登录
    async handleBackToSignIn() {
      try {
        await userSignOut()

        this.refreshUserInfo(null)
        this.resetKeepAliveInclude()
        this.resetSysRepeatDataNum()

        this.$router.push({ path: '/user' })
      } catch (error) {}
    },

    //发送验证码
    sendSuccess(data){
      // 先验证手机号，再请求验证码
      this.form.validateFields(['newMobile'], { force: true }, async (err, values) => {
        console.log(err, values)
        if (!err) {
          try {
            let  param ={
              "browserInfo": "",
              "captchaFontSize": 0,
              "captchaFontType": "",
              "captchaId": "",
              "captchaOriginalPath": "",
              "captchaType": "blockPuzzle",
              "captchaVerification": data.captchaVerification,
              "clientUid": "",
              "jigsawImageBase64": "",
              "originalImageBase64": "",
              "point": {
                "secretKey": "",
                "x": 0,
                "y": 0
              },
              "pointJson": "",
              "pointList": [{
                "x": 0,
                "y": 0
              }],
              "projectCode": "",
              "result": true,
              "secretKey": "",
              "token": "",
              "ts": 0,
              "wordList": []
            }
            // 发送验证码请求
            sendChangePasswordPhoneCode({userId: this.userInfo.id}, param).then(res=>{
              if (res && res.data.success){
                // 设置按钮禁用，且准备显示倒计时
                this.gettingVerifyCode = true;
                // 开启倒计时
                this.interval = setInterval(() => {
                  if (this.timeCountDown-- <= 0) this.resetPhoneCode()
                }, 1000);
                // 关闭请求等待提示框
                this.$notification.success({
                  message: this.$t('userRegister.varifyCodeSendSuccess'),
                  description: ''
                })
              }
            })
          } catch (error) {
            // 关闭请求等待提示框
            this.resetPhoneCode()
          }
        }
      })
    },
  }
}
</script>

<style lang="less">
.user-change-password {
  &.error {
    color: #ff0000;
  }

  &.warning {
    color: #ff7e05;
  }

  &.success {
    color: #52c41a;
  }
}

.user-layout-change-password {
  .ant-input-group-addon:first-child {
    background-color: #fff;
  }
}
</style>
<style lang="less" scoped>
.main {
  width: 420px !important;
  margin-top: 32px;
}
</style>
